import React, { useState, useEffect, useRef } from "react";
import Calendar from "moedim";
import "./dashboard.css";
import strings from "../../utils/property-file/dashboard.json";
import api from "../../services/api.js";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import SpinnerButton from "../button/spinnerButton.js";
import constants from "../../utils/constants.js";
import debounce from "../../utils/commonFunction/debounce.js";
import {
  extractTime,
  convertUtcToIst,
  TimeDifferenceCalculator,
} from "../../utils/commonFunction/timeConvertor.js";
import Export from "../../Asset/Images/export-report.svg";
import ExportCompanyAttendanceReport from "./exportPopUp/exportCompanyAttendanceReport.js";
import { CompanyLevelAttendanceContext } from "../companyLevelAttendanceContext.js";
import { useContext } from "react";

export default function Dashboard() {
  const [refreshAttendance, setRefreshAttendance] = useState(false);
  const [generatingReport , setGeneratingData] = useState(false);
  const { setAttendanceData } = useContext(
    CompanyLevelAttendanceContext
  );
  const [emptyMsg, setEmptyMsg] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const [employee, setEmployee] = useState([]);
  const [loadingAttendance, setLoadingAttendance] = useState(true);
  const debounceOnChange = React.useCallback(
    debounce(handleEmpLoyeeSearch, 600),
    []
  );
  const [dateAttendance, setDateAttendance] = useState(new Date());
  const [empSearchName, setEmpSearchName] = useState("");
  const buttonRef = useRef(null);
  const nav = useNavigate();
  const [exportModalShow, setExportModalShow] = useState(false);
  const handleClickOutside = (event) => {
    if (buttonRef.current && !buttonRef.current.contains(event.target)) {
      setShowCalendar(false);
    }
  };
  const [attendanceDataFetched, setAttendanceDataFetched] = useState(false);

  useEffect(() => {
    document.addEventListener(strings.clickLabel, handleClickOutside);
    return () => {
      document.removeEventListener(strings.clickLabel, handleClickOutside);
    };
  }, []);

  function handleEmpLoyeeSearch(value) {
    setEmpSearchName(value.trim());
  }

  const handleDateChange = (value) => {
    setDateAttendance(value);
    setShowCalendar(false);
  };

  // Below method is for fetching attendance data for selecting date
  const generateReport = async () => {
    try {
      setGeneratingData(true)
      const response = await api.getCompanyAttendanceData(
        moment(dateAttendance).format(strings.yyMMDDFormat)
      );
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if(response.success){
          setAttendanceData(data);
          setAttendanceDataFetched(true);
        }
        else{
          setAttendanceData([]);
        }
        setGeneratingData(false)
      }
    } catch (error) {
      setGeneratingData(false)
      toast.error(strings.somethingWentWrongLabel , {toastId : "error6"})
    }
  };

  const date = new Date();
  const today_date = moment(date).format(
    constants.dateFormatStrings.dateMonthLabel
  );
  const displayDate = moment(new Date(dateAttendance)).format(
    constants.dateFormatStrings.dateMonthLabel
  );


  // API call for fetching attendance
  // Params date :  YYYY/MM/DD , name : ""
  const fetchEmployeeData = async (name) => {
    try {
      setLoadingAttendance(true);
      const date = moment(dateAttendance).format(
        constants.dateFormatStrings.monthDateLabel
      );
      const employeeName = name ? name : "";
      const params = { date, employeeName };
      const response = await api.showEmployeeAttendance({ params });
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          setEmployee(data.body);
          console.log("data.body",data.body);
          
        } else {
          setEmployee([]);
          setEmptyMsg(data.body)
        }
        setLoadingAttendance(false);
        setRefreshAttendance(false);
      }
    } catch (error) {
      setLoadingAttendance(false);
      setRefreshAttendance(false);
    }
  };

  useEffect(() => {
    setDateAttendance(dateAttendance);
    fetchEmployeeData(empSearchName);
  }, [dateAttendance]);

  useEffect(() => {
    if (empSearchName.length >= 3) {
      fetchEmployeeData(empSearchName);
    } else if (empSearchName.length === 0) {
      fetchEmployeeData("");
    }
  }, [empSearchName]);

  return (
    <>
      <div className="search-bar">
        <input
          className="search-bar search-emp dashboard-search-bar"
          type="text"
          placeholder={strings.searchPlaceholder}
          onChange={(e) => {
            debounceOnChange(e.target.value);
          }}
        />
      </div>
      <div>
        <div>
          <div>
            <div className="dashboard-head-content">
              <span className="dashboard-heading">
                {displayDate === today_date
                  ? strings.dashboardHeading
                  : displayDate + " " + strings.timeSheetLabel}
              </span>
              <div className="d-flex">
                <div className="export-button">
                  <img
                    src={Export}
                    alt="export-icon"
                    title="Export Report"
                    onClick={() => {
                      localStorage.setItem(strings.localStorageExport,moment(dateAttendance).format(strings.yyMMDDFormat))
                      localStorage.setItem(strings.localStorageSelectedDate,moment(dateAttendance).format(strings.ddMMFormat))
                      setExportModalShow(true);
                      generateReport();
                    }}
                  />
                </div>
                {moment(dateAttendance)
                  .format(constants.dateFormatStrings.dateMonthLabel)
                  .toString() ===
                moment(new Date())
                  .format(constants.dateFormatStrings.dateMonthLabel)
                  .toString() ? (
                  <span
                    className={
                      refreshAttendance
                        ? "refresh-button-animation me-2"
                        : "refresh-button me-2"
                    }
                    title="Refresh"
                    onClick={() => {
                      fetchEmployeeData();
                      setRefreshAttendance(true);
                    }}
                  >
                    <i className="ri-restart-line text-light"></i>
                  </span>
                ) : null}
                <button className="btn-dashboard" ref={buttonRef}>
                  <div
                    onClick={() => {
                      setShowCalendar(!showCalendar);
                    }}
                  >
                    <span>
                      {displayDate === today_date ? strings.today : displayDate}
                    </span>
                    <i className="ri-calendar-event-line"></i>
                  </div>
                  {showCalendar && (
                    <div className="calender-ui">
                      <Calendar
                        className="dashboard-calendar"
                        value={dateAttendance}
                        maxDate={date}
                        onChange={handleDateChange}
                      />
                    </div>
                  )}
                </button>
              </div>
            </div>
            <div className="table-layout mt-3 mx-auto table-data  employee-attendance">
              <table className="table">
                <thead className="employee-status-header">
                  <tr>
                    <th scope="col">{strings.serialNumberLabel}</th>
                    <th scope="col">{strings.tableHeadName}</th>
                    <th scope="col">{strings.tableHeadType}</th>
                    <th scope="col">{strings.tableHeadStatus}</th>
                    <th scope="col">{strings.tableHeadSignIn}</th>
                    <th scope="col">{strings.tableHeadSignOut}</th>
                    <th scope="col">{strings.durationLabel}</th>
                  </tr>
                </thead>
                {loadingAttendance ? (
                  <div className="table-loader">
                  <SpinnerButton />
                  </div>
                ) : (
                  <tbody className="employee-status-body">
                    {employee.length > 0 ? (
                      employee.map((employee, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}.</td>
                            <td
                              className="emp-name-field"
                              onClick={() => {
                                localStorage.setItem(
                                  constants.localStorage.selectedEmployeeId,
                                  employee.userId
                                );
                                nav(constants.navigationLink.employeeData);
                              }}
                            >
                              {employee.name}
                            </td>
                            <td>{employee.employmentType?employee.employmentType: strings.notAssignedLabel}</td>
                            {employee.workingLocation!=null ?
                              <td
                              className="hint  hint--right"
                              data-hint={
                                employee.workplace === strings.wfhLabel
                                  ? employee.workingLocation
                                    ? employee.workingLocation
                                    : null
                                  : null
                              }
                            >
                              {employee.workplace}
                            </td> :
                            <td>
                              {employee.workplace}
                            </td>}
                            <td>
                              {extractTime(convertUtcToIst(employee.inTime))}
                            </td>
                            <td>
                              {employee.outTime
                                ? extractTime(convertUtcToIst(employee.outTime))
                                : strings.workingLabel}
                            </td>
                            <td>
                              {employee.inTime!==null && employee.outTime!==null ? <TimeDifferenceCalculator time1={moment(employee.inTime).format(strings.hhMMFormat)}  time2={moment(employee.outTime).format(strings.hhMMFormat)}/>:strings.emptyData}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          {emptyMsg}
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </table>
            </div>
          </div>
        </div>
      </div>
      {exportModalShow && (
        <ExportCompanyAttendanceReport
          show={exportModalShow}
          reportGeneration={generatingReport}
          selectedDate={displayDate}
          attendanceDataFetch={attendanceDataFetched}
          onHide={() => setExportModalShow(false)}
        />
      )}
    </>
  );
}